import styled from 'styled-components';
import { Group } from '@vx/group';

import { Container as ContainerComponent } from '../charts.styles';
export const SpiderGroup = styled(Group)`
  .vx-line {
    shape-rendering: geometricPrecision;
  }
`;

export const SerieGroup = styled.g`
  transition: opacity 0.3s ease-in;
  opacity: ${({ isHoverActive, isGroupHovered }) => (isHoverActive && !isGroupHovered ? 0.3 : 1)};
`;

export const Container = styled(ContainerComponent)`
  padding: 0 0 10px;
  margin: 0 0 30px 0;
`;
